export default "<h2>404 - Page not found</h2>\n<p>\n  You might want to go to the\n  <a routerLink=\"/\"><strong>Second-Consult.com</strong></a>\n</p>\n"